import { Route, Routes } from "react-router-dom";
import { PdfExtractorIcms } from "./list";

export function PdfExtractorIcmsRoutes() {
    return (
        <Routes>
            <Route path="/" element={<PdfExtractorIcms />} />
        </Routes>
    )
}